import type { IValidatedResponse } from '../../../httpClient';
import { postRequest } from '../../../httpClient';
import type { IGrantManualSubscriptionRequest } from './grant-manual-subscription-request';
import type { IGrantManualSubscriptionResponse } from './grant-manual-subscription-response';
import { grantManualSubscriptionResponseSchema } from './grant-manual-subscription-response';

export async function grantManualSubscriptionApi(
  body: IGrantManualSubscriptionRequest,
): Promise<IValidatedResponse<IGrantManualSubscriptionResponse>> {
  return postRequest<IGrantManualSubscriptionResponse>({
    path: '/sys/billing/subscriptions/manual',
    schema: grantManualSubscriptionResponseSchema,
    body,
  });
}
